<template>
<div>   
<SearchBar :moduleName="currentModuleName"  :showCommonAdvancedSearch.sync="showCommonSearch">  
 <slot></slot>
    <el-button slot="equipSearchButton" type="primary" round @click="handleShowEquipFilter(true)">装备筛选</el-button> 
      <el-button type="primary" @click="chooseEquip" slot="buttons">继续选择装备...</el-button> 
</SearchBar>

<el-dialog :visible.sync="showEquipFilter" :center="false" width="1100px"  :append-to-body="true" title="装备筛选">
  <el-row>
    <el-col :span="12">  <el-button type="primary" @click="clearLineSearch"  >清除车型选项</el-button> <el-button type="primary" @click="viewLineSearch">查看车型选项</el-button>   </el-col>
    <el-col :span="12"  style="  text-align:right;">

 
           <el-select v-model="selectedSchemaID" placeholder="请选择结果集" @change="onSelectedSchemaChanged">
               <el-option label="新搜索方案" value="0"> </el-option>              
               <el-option v-for="(item,index) in savedEquipSearchSchemas" :key="index" :label="item.name" :value="item.id"></el-option>
           </el-select>
 
    </el-col>
  </el-row>
 
<div style="border-top: 1px solid #eaeefb; margin:15px 0;"></div>
  <el-row>
      <el-col :span="12">
           <div class="leftbox">            
            <div>  
              <el-input placeholder="请输入内容" v-model="keyword" class="input-with-select" clearable prefix-icon="el-icon-search">
              <el-select v-model="equipType" slot="prepend" placeholder="全部装备" style="width: 130px;">
              <el-option label="全部装备" value="全部"> </el-option>
    <el-option
      v-for="item in this.equipCategories"
      :key="item"
      :label="item"
      :value="item">
    </el-option>
  </el-select> 
  </el-input></div>
  <div>
      <el-table :data="SelectionTags" style="width: 100%"  height="450">
      <el-table-column prop="name" label="装备名称" width="180"> </el-table-column>
      <el-table-column prop="val" label="装备选项" min-width="180"> </el-table-column>
        <el-table-column label="操作"  width="120" >
          <template slot-scope="scope">
            <el-button @click="handleContain(scope.$index, scope.row)" icon="el-icon-plus" circle  :type="scope.row.status==2?'primary':''">  </el-button>
            <el-button @click="handleRemove(scope.$index, scope.row)" icon="el-icon-minus" circle  :type="scope.row.status==4?'primary':''"> </el-button>  
          </template>
        </el-table-column>
  </el-table> 
  </div>
  </div>
</el-col> 
          <el-col :span="12">           
                <p class="ttip"><strong>包含</strong> 如下装备 ...</p>
                <div class="containbox">
                      <el-tag :key="tag.id" v-for="tag in includeTags" closable :disable-transitions="false" @close="handleClose(tag)">{{tag.name +':'+ tag.val}}</el-tag>
                </div>
            <p class="ttip"><strong>排除</strong> 如下装备 ...</p>
                <div class="containbox">
                      <el-tag :key="tag.id" v-for="tag in removeTags" closable :disable-transitions="false" @close="handleClose2(tag)">{{tag.name +':'+ tag.val}}</el-tag>
                </div>
          </el-col>
  </el-row>
            <span slot="footer"  >
                <el-button @click="handleShowEquipFilter(false)">返回</el-button>
                 <el-button @click="saveSearchSchema">保存为搜索方案</el-button>
                <el-button  @click="search" type="primary">搜索装备</el-button>
            </span>

</el-dialog> 

 <el-dialog title="方案名称"
            :visible.sync="showNameInput"
            :center="false"
            :append-to-body="true">
            <span slot="dialog-title"> </span>
            <el-input v-model="schemaName"></el-input>
            <span slot="footer">
                <el-button @click="hideNameInput">取消</el-button>
                <el-button @click="confirmNameInput" type="primary">保存</el-button>
            </span>
        </el-dialog>
</div>
</template>
<script>

import SearchBar from '@/components/common/CommonSearch.vue';
import {mapActions, mapGetters, mapMutations ,mapState} from 'vuex';
import { clearTimeout } from 'timers';
import ApiUrl from '../../store/apiurl';
import GUID from  '../../store/guid';
import Axios from 'axios';
 
export default {
    name: 'equipanalysis',
    components: {
        SearchBar
    },
     props:{
       currentModuleName:{type:String ,required:true},
 
    },
    data() {
        return {
          selectedSchemaID:"0",
          showNameInput:false,
          schemaName:'',
          equipType:'全部',
           currentClass1:'',
           currentClass2:'',
           showEquipFilter:false,
           showCommonSearch:false,
           daterange:'',
        
           pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
       
        keyword:'',
        value:'',

        }
    },
    methods:{
  ...mapMutations('commonsearch', [
            'clearCurrentSearchSchema' ,
        ]),
       ...mapActions('searchequip', [
            'saveEquipSearchSchema',
            'queryEquipList',
            'doSearch',
            'loadEquipSearchSchema',
            'selectEquipSearchSchema'
        ]),
        ...mapMutations('searchequip', [
                'setCurrentModuleName','clearCurrentSearchSchema'
        ]),
      chooseEquip(){

         //  alert(JSON.stringify(this.searchParams));
           this.showCommonSearch = false ;
           this.handleShowEquipFilter(true);
            
        },
        clearLineSearch(){

            this.clearCurrentSearchSchema();
              this.$message({
                message:  '已清理',
                duration: 2000,   
            });

        },
        viewLineSearch(){
            this.showCommonSearch = true ;
             this.handleShowEquipFilter(false);
             

        },
     gotoAnalyze(){},
         mouseEnter(i){
         this['currentClass'+i] = 'grid-hover';
        },
       mouseLeave(i){
            this['currentClass'+i] = '';
      },
      handleShowEquipFilter(visible)
      {
          this.showEquipFilter = visible;
      },
      handleContain(index, row){

          row.status = 2;
          console.log(index, row);
      },
      handleRemove(index, row){
              row.status = 4;
        console.log(index, row);

      },
          // 隐藏名称输入
        hideNameInput() {
            this.showNameInput = false;
        },
        onSaved(res) {
            this.$message({
                message: res ? '已保存' : '保存失败',
                duration: 2000,   
            });
        },
        // 确认名次输入
        confirmNameInput() {
      
            if(this.schemaName) {
                var key = new GUID().newGUID();
                this.saveEquipSearchSchema({schemaId:key, name: this.schemaName,action:'add', cb: this.onSaved });
                this.hideNameInput();
            }
        },
      saveSearchSchema(){
        this.showNameInput = true;
      },
       handleClose(tag) {
        tag.status = 1;
      },
       handleClose2(tag) {
        tag.status = 1; 
      },
      onSelectedSchemaChanged(val) {
            if(val === '0') {
              this.clearCurrentSearchSchema();
            } else {
             this.selectEquipSearchSchema(val);
            }
        },
        search()
        {
          //postData = {include:[7,8,9,10],exclude:[2,3,4,5]}
          var postData = {include: this.includeTags.map(x=>x.id), exclude:this.removeTags.map(x=>x.id) ,lineParams: this.searchParams };
          console.log("postData = ");
           console.log(postData);
          this.doSearch(postData);
          this.handleShowEquipFilter(false);
        },
        async initData() {
            await this.loadEquipSearchSchema();
            
          if(this.equipOptions==null || this.equipOptions.length ==0)
           {

                await this.queryEquipList();
           }
        }
    },
    computed: {


      includeTags(){
        return this.equipOptions.filter(item=>{return item.status == 2});
      },
      removeTags(){
        return this.equipOptions.filter(item=>{return item.status == 4});
      },
      SelectionTags(){
      
         return this.equipOptions.filter(item=>{return     (this.keyword=='' || (item.val.indexOf(this.keyword)>-1) || item.name.indexOf(this.keyword)>-1 )  && (this.equipType=='全部' ||item.tag== this.equipType) });
      },
      ...mapGetters('searchequip', [
            'savedEquipSearchSchemas',
            'searchParams',
            'equipOptions',
            'equipCategories','getSavedEquipSearchSchema'
        ]),
          ...mapGetters('commonsearch', [
          'searchParams'
        ]),
    },
    mounted(){
 
         this.setCurrentModuleName(this.currentModuleName);  
         this.initData();
    },
    

}
</script>
<style scoped>
.equip-main{  padding: 80px 60px; }
.grid-hover{   color: rgb(0, 162, 255); box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.2); }
.grid-content{ box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);  padding: 10px; min-height: 260px; cursor: pointer; }
.grid-content .icon{ margin-top:3em;}
.grid-content .icon i {font-size: 3em;}
.search-wrapper {  line-height: 24px;}
.label{  line-height: 40px;}
.leftbox, .containbox,.removebox{  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); padding:8px;}
.ttip{ padding-left:20px;}
.el-tag + .el-tag {margin-left: 10px; margin-top:10px;}
.containbox,.removebox{ margin-left: 20px; min-height: 190px;}
.el-table::before{ height:0;}
</style>

 